/* src/app/dashboard/dashboard.component.css */
.grid-container {
  margin: 20px;
}
.dashboard-card {
  position: absolute;
  top: 15px;
  left: 15px;
  right: 15px;
  bottom: 15px;
}
.white_text {
  color: #ffffff;
}
.marketing-title-box {
  background-color: #ffffff;
  border-color: #e1e1e1;
  border-width: 2px;
  border-style: solid;
  padding: 5px 5px 5px 20px;
  height: 90px;
  color: var(--primary-color);
  margin-bottom: 10px;
  margin-top: 15px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
.marketing-title-box a {
  height: 100%;
}
.marketing-image {
  max-height: 100%;
  display: block;
  max-width: 100%;
}
.banner-a {
  display: flex;
  align-items: center;
  margin-left: 5px;
}
.more-button {
  position: absolute;
  top: 5px;
  right: 10px;
}
.dashboard-card-content {
  text-align: center;
  height: 80%;
}
.dashboard-card-recents {
  text-align: center;
  height: 100%;
}
.dashboard-padding-fix {
  padding: 0px 16px !important;
}
.grid-container {
  margin: 0px -15px 0px -15px;
}
.mat-mdc-card-title {
  color: #ffffff;
  font-weight: bold;
  padding: 8px 8px 8px 8px;
  line-height: 42px;
  width: 100%;
}
.mat-mdc-card-title div {
  width: 100%;
}
.lb-info-button {
  height: 32px;
  justify-content: flex-start;
  padding-left: 5px;
}
.menu-button {
  float: right;
  width: 135px;
  height: 32px;
}
.menu-tab {
  float: left;
  background-color: var(--primary-color);
  color: #ffffff;
  width: 100px;
  height: 32px;
}
.mat-mdc-card {
  padding: 0px 0px 16px 0px;
}
.mat-mdc-card-header {
  background-color: var(--primary-color);
}
.mat-mdc-card-content {
  padding: 16px;
}
.card-header {
  background-color: var(--primary-color);
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 8px 16px 7px 16px;
}
.card-title {
  font-family:
    Figtree,
    "Helvetica Neue",
    sans-serif;
  color: #ffffff;
  display: flex;
  flex: 1 1 auto;
  line-height: 32px;
}
.card-title > div {
  width: 100%;
}
.centered_block_child {
  position: absolute;
  top: 50%;
  transform: translateY(-40%);
  width: 100%;
}
.full-height {
  height: 100%;
}
.menu_button_container {
  display: flex;
  justify-content: flex-start;
  position: relative;
  width: 100%;
  height: 100%;
  margin: 0;
}
.menu_button_center {
  flex: 0 1 auto;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}
.men_button_right {
  flex: 0 1 auto;
  margin-left: auto;
  display: flex;
  align-items: center;
}
.menu_button_text {
  font-weight: bold;
}
.menu_button_carret {
  margin-right: -40px !important;
  margin-left: 20px !important;
}
.menu_button_carret_long {
  margin-right: -15px !important;
  margin-left: 20px !important;
}
.spacing {
  margin-top: 20px;
  margin-bottom: 20px;
}
.remove-underline {
  text-decoration: none;
}
.rounded-corners {
  border: 2px solid green;
  border-radius: 25px;
}
.formatImg {
  object-fit: cover;
  height: 100%;
  width: 100%;
  margin: 1px;
}
.tiles {
  background: var(--primary-color);
  color: white;
}
.tile-icon {
  color: var(--secondary-color);
  padding: 5px;
  margin: 0px 5px;
  vertical-align: top;
  display: inline-block;
}
.tile-text {
  padding: 5px 0px;
  vertical-align: top;
  font-size: 20px;
  display: inline-block;
}
.tab-content {
  padding: 10px 5px;
}
.sm_green {
  color: var(--primary-color);
}
.sm_green_background {
  background-color: var(--primary-color);
}
.card_title_text {
  color: #ffffff;
  margin: 2px 0px !important;
}
.mt {
  margin-top: 10px !important;
}
.ml {
  margin-left: 10px;
}
.mr {
  margin-right: 10px;
}
.date_picker_container {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  flex-wrap: wrap;
}
.search_container {
  display: flex;
  gap: 10px;
}
.search_contianer_input {
  flex: 2 1 auto;
}
.search_continer_button {
  max-width: 50px;
}
.accordian-headers-align .mat-expansion-panel-header-title,
.accordian-headers-align .mat-expansion-panel-header-description {
  flex-basis: 0;
}
.accordian-headers-align .mat-expansion-panel-header-description {
  justify-content: space-between;
  align-items: center;
}
.results-card {
  width: 250px;
  height: auto;
}
.results-card-cta {
  width: 250px;
  height: auto;
}
.results-header-image {
  background-size: cover;
}
.panel-body {
  display: flex;
  gap: 10px 10px;
  flex-wrap: wrap;
  padding: 2%;
  justify-content: space-around;
}
.mat-mdc-card-content {
  flex-grow: 1;
  overflow: auto;
}
.mat-mdc-card {
  display: flex;
  flex-direction: column;
}
.date {
  font-size: 12px;
  color: #222222;
  font-style: italic;
}
.no_overflow {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.mat-mdc-card-header {
  overflow: hidden;
}
.title_case {
  text-transform: capitalize;
}
.card_image {
  width: 100%;
  margin: 5px auto;
}
.sub_text {
  color: #ffffff;
  font-size: 14px;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-bottom: 4px;
}
.card_title_text2 {
  color: #ffffff;
  margin: 2px 0px 0px 0px !important;
  font-size: 20px;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.card_header {
  background-color: var(--primary-color);
  padding-left: 16px;
  padding-right: 16px;
  text-align: left;
}
.header-icon {
  background-color: var(--green-accent);
  color: #ffffff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
}
mat-card-title,
mat-card-subtitle {
  color: #ffffff;
}
.results-card mat-card-title {
  font-size: 18px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.results-card mat-card-subtitle {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 12px;
}
.truncate {
  width: 250px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.thumbnail {
  object-fit: cover;
  border-width: 2px;
  border-style: solid;
  width: 100%;
  height: 200px;
  border-bottom-left-radius: var(--app-border-radius);
  border-bottom-right-radius: var(--app-border-radius);
  border-color: var(--primary-color);
}
.thumbnailBtn {
  width: 60%;
  height: 75%;
  background: none;
  position: relative;
  display: inline-block;
}
.centeredCell {
  text-align: center;
}
.title-text {
  font-size: 14px;
  text-align: left;
  padding: 15px 15px 5px 15px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  box-sizing: border-box;
}
.mat-mdc-card {
  padding-bottom: 5px;
}
.recents-comment {
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 8px;
}
.comment-meta {
  font-size: 12px;
  color: #666;
  margin-bottom: 4px;
}
.info-link {
  width: 100%;
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.mat-mdc-outlined-button {
  position: absolute;
}
.details-button-comments {
  margin-left: 8px;
}
.details-button {
  position: relative;
}
::ng-deep .mat-tab-label-active {
  background-color: #177b4d;
}
.tab-label {
  color: rgba(255, 255, 255, 0.5);
}
.selected-tab-label {
  color: #ffffff;
}
.alert {
  margin: 10px 0px;
  border-radius: 12px;
  padding: 16px 22px;
  display: flex;
  align-items: center;
  flex: 2 1 auto;
  border-width: 2px;
  border-style: solid;
}
.alert-warning {
  background: #fff3cd;
  border-color: #ffeeba;
}
.alert-success {
  background-color: #d4edda;
  border-color: #c3e6cb;
}
.alert-primary {
  background-color: #cce5ff;
  border-color: #b8daff;
}
.alert-dark {
  background-color: #e2e3e5;
  border-color: #d6d8db;
}
.alert-error {
  background-color: #f8d7da;
  border-color: #f5c6cb;
}
.alert .icon__wrapper {
  height: 34px;
  width: 34px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.253);
  display: flex;
  align-items: center;
  justify-content: center;
}
.alert .icon__wrapper span {
  font-size: 21px;
  color: #fff;
}
.alert p {
  font-family: Verdana;
  margin: 5px 10px;
}
.alert-warning p {
  color: #856404;
}
.alert-primary p {
  color: #004085;
}
.alert-error p {
  color: #721c24;
}
.alert-dark p {
  color: #383d41;
}
.alert-success p {
  color: #155724;
}
.dashboard-menu-button-container {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
}
.dashboard-menu-button {
  background-color: var(--green-accent) !important;
  min-width: 150px;
  height: 32px;
}
.dashboard-inner-menu-button-container {
  display: flex;
  justify-content: space-between;
  position: relative;
  width: 100%;
  height: 100%;
  margin: 0;
}
.dashboard-menu-button-center {
  margin: auto 5px;
  color: var(--primary-color);
  font-weight: bold;
  color: #FFFFFF;
}
.dashboard-menu-button-right {
  display: flex;
  align-items: center;
  width: 24px;
  color: #FFFFFF;
}
.dashboard-menu-button-left {
  flex: 0 1 auto;
  width: 24px;
}
/*# sourceMappingURL=dashboard.component.css.map */
